module.exports = __webpack_public_path__ + "img/lc02.c4705871.png";